module.exports = __webpack_public_path__ + "73d987a19f460a5aedfe0d01812255d8.png";